module.exports = "build/assets/darkBlueWave.1d092e66.png";